/**
 * @file Created on Wed Aug 22 2018
 * @author SKu
 */
import ConfirmBox from './ConfirmBox';
export default ConfirmBox;